/**
 * Class Add Tabs.
 */
export default class Tabs {
  /*
   * Create Tabs event
   * */
  public static create(selectorTabs: string) {
    const tabList = document.querySelector(selectorTabs);
    const tabs: NodeListOf<HTMLElement> =
      tabList.querySelectorAll('[role="tab"]');

    // Add a click event handler to each tab
    tabs.forEach((tab) => {
      tab.addEventListener(
        'click',
        (
          e: MouseEvent & {
            target: HTMLButtonElement;
          }
        ) => {
          const { target } = e;
          const parent = target.closest('[role="presentation"]');
          const grandparent = parent.closest('.c-tabs__wrapper');

          // Remove all current selected tabs
          grandparent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute('aria-selected', 'false'));

          // Set this tab as selected
          target.setAttribute('aria-selected', 'true');

          // Hide all tab panels
          grandparent
            .querySelectorAll('[role="tabpanel"]')
            .forEach((p) => p.setAttribute('hidden', 'true'));

          // Show the selected panel
          grandparent.parentNode
            .querySelector(`#${target.getAttribute('aria-controls')}`)
            .removeAttribute('hidden');
        }
      );
    });

    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;

    tabList.addEventListener('keydown', (e: KeyboardEvent) => {
      // Move right
      if (e.code === 'ArrowRight' || e.code === 'ArrowLeft') {
        tabs[tabFocus].setAttribute('tabindex', '-1');
        if (e.code === 'ArrowRight') {
          tabFocus += 1;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.code === 'ArrowLeft') {
          tabFocus -= 1;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute('tabindex', '0');
        tabs[tabFocus].focus();
      }
    });
  }
}
